"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerStyle = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var colors_1 = require("../../styles/colors");

var theme_1 = require("../../styles/theme");

var Spinning = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
var WIDTH = {
  xxs: 24,
  xs: 40,
  sm: 56,
  md: 64,
  lg: 96
};

exports.spinnerStyle = function (_a) {
  var size = _a.size;
  var width = WIDTH[size];
  return styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\tborder-radius: 50%;\n\t\tanimation: ", " 1s linear infinite;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\tborder: ", "px solid ", ";\n\t\tborder-top: ", "px solid ", ";\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t"], ["\n\t\tborder-radius: 50%;\n\t\tanimation: ", " 1s linear infinite;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\tborder: ", "px solid ", ";\n\t\tborder-top: ", "px solid ", ";\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t"])), Spinning, width / 10, colors_1.gray[100], width / 10, theme_1.primary[500], width, width);
};

var templateObject_1, templateObject_2;